<app-pass-type-select
  [formControl]="passTypesFormControl"
  [allowMultiple]="true"
  [allowed]="passTypes"
></app-pass-type-select>
